
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/material-ui-is-now-mui",
      function () {
        return require("private-next-pages/blog/material-ui-is-now-mui.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/material-ui-is-now-mui"])
      });
    }
  